<template>
  <img src="@/assets/images/logos/olypmic-kz_1.webp"/>
</template>
<script setup>
</script>